/** One entry behind the warning sign next to an order's name: a stored notice, or a warning computed from the order's data. */
export interface OrderAlert {
  id: string
  title: string
  body: string
  /** Who can read it, for an alert not every order member sees; null when everyone does. */
  audience: string | null
  resolved: boolean
}

export const alertTitles = (items: Array<{ title: string }>): string => items.map((item) => item.title).join(' · ')
